export const getOptions = categories => ({
    dataLabels: {
        enabled: true,
        formatter: val => {
            return Number(val).toLocaleString() + "%";
        },
        offsetY: -20,
        style: {
            fontSize: 10,
            colors: ["#304758"],
        },
    },
    xaxis: {
        categories,
        position: "bottom",
        labels: {
            offsetY: 0,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        crosshairs_: {
            fill: {
                type: "gradient",
                gradient: {
                    colorFrom: "#D8E3F0",
                    colorTo: "#BED1E6",
                    stops: [0, 100],
                    opacityFrom: 0.4,
                    opacityTo: 0.5,
                },
            },
        },
        tooltip: {
            enabled: false,
            offsetY: -35,
        },
    },
    stroke: {
        show: true,
        width: 1,
        colors: ["#fff"],
    },
    yaxis: {
        show: true,
        axisBorder: {
            show: true,
        },
        axisTicks: {
            show: true,
        },
        decimalsInFloat: 2,
        labels: {
            show: true,
            style: {
                colors: "gray",
                fontSize: 10,
            },
            formatter: val => {
                return Number(val).toLocaleString() + "%";
            },
        },
        forceNiceScale: true,
    },
    chart: {
        animations: {
            enabled: true,
        },
    },
});
